import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LinkRoutingModule} from "./link-routing.module";

import {LinkComponent} from './link.component';
import {ComponentsModule} from "../shared/components/components.module";
import {RouterModule} from "@angular/router";
import {PipesModule} from "../shared/pipes/pipes.module";


@NgModule({
  declarations: [
    LinkComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    ComponentsModule,
    LinkRoutingModule,
  ]
})
export class LinkModule {
}
